import { Box, Button, MenuItem, Select, Typography } from "@mui/material";
import { Formik } from "formik";
import React from "react";
import { getIDSRules } from '../services/ids_services'

const DownloadIDSRulesForm = (props) => {

    const downloadRules = async (values) => {
        try {
            await getIDSRules(values)
        } catch (error) {
            console.log('Error ', error)
        }
       
    }


  return (
    <Formik
      initialValues={{
        return_format: "suricata",
      }}
      onSubmit={(values) => {
        console.log("SUBMIT ", values);
        downloadRules(values)
      }}
    >
      {({
        handleChange,
        handleBlur,
        handleSubmit,
        resetForm,
        submitForm,
        values,
      }) => (
        <Box>
          <Box
            sx={{
              display: "flex",
              flex: 1,
              alignItems: "center",
              justifyContent: "space-evenly",
              marginBottom: 5,
            }}
          >
            <Typography sx={{ marginRight: 2 }}> Download Format</Typography>
            <Select
              labelId="demo-simple-select-helper-label"
              id="return_format"
              value={values.return_format}
              label="Sort By"
              onChange={handleChange("return_format")}
              variant="outlined"
              size="small"
            >
              <MenuItem value={"suricata"}>Suricata</MenuItem>
              <MenuItem value={"snort"}>Snort</MenuItem>
              <MenuItem value={"xml"}>XML</MenuItem>
              <MenuItem value={"json"}>JSON</MenuItem>
              <MenuItem value={"openioc"}>OpenIOC</MenuItem>
            </Select>
          </Box>
          <Button
              variant={"contained"}
              onClick={() => {
                handleSubmit();
              }}
            >
              Download
            </Button>
           
        </Box>
      )}
    </Formik>
  );
};

export default DownloadIDSRulesForm;
